<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="View Vehicle Bus Stop Details">
        <v-card-actions>
             <v-btn absolute right top elevation="1" color="primary" @click="toggleStaffModal()">
              <v-icon left>mdi-plus</v-icon>
              Create Bus Stop
            </v-btn>
        </v-card-actions>
        <v-card-component>
          <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
            <v-card-title>
              Total Records : {{ total }}
              <v-spacer></v-spacer>
            </v-card-title>
            <v-text-field
              :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
              v-model="search"
              append-icon="mdi-magnify"
              class="ml-auto mb-2"
              label="Search"
              hide-details
              single-line
              style="max-width:350px;"
            />
          </v-card-text>
          <v-divider class=" my-0 " />
          <v-data-table
            :footer-props="{
              'items-per-page-options': [5, 10, 20, 40]
            }"
            :items-per-page="10"
            :headers="headers"
            :items="vehicleBusRouteStop"
            :search="search"
          >
            <template v-slot:item.nearestLandMark="{ item }">
              {{ item.nearestLandMark || '-' }}
            </template>
            <template v-slot:item.distance="{ item }">
              {{ item.distance || '-' }}
            </template>
            <template v-slot:item.actions="{ item }">
              <div>
                <v-btn x-small class="px-2 ml-1 ma-1" color="red" outlined @click.prevent="editBusRoute(item.id)">
                 <v-icon small> mdi-pencil</v-icon>
                </v-btn>
              </div>
            </template>
            <template v-slot:no-data>
              <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
            </template>
          </v-data-table>
        </v-card-component>
      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
    <div class="modal" :class="{ 'is-active': enableStaffModal }">
        <form @submit.prevent="SaveRoute">
          <v-card>
            <v-toolbar dark color="darkblue">
              <v-toolbar-title> Add Bus Stop For Bus Route - {{ busRoute}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn icon dark @click="toggleStaffModal, clearEditRemark()">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <v-row style="width:1000px;">
                <v-col cols="12" md="6">
                  <v-text-field  label="Pick Up Stop" required v-model="pickUpStop" type="text"> </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field   label="Nearest LandMark" required v-model="nearestLandMark" type="text"> </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field label="Lattitude" v-model="lattitude" type="text"> </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field label="Longitude" v-model="longitude" type="text"> </v-text-field>
                </v-col>
                 <v-col cols="12" md="6">
                  <v-text-field  label="Distance" required v-model="distance" type="number"> </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field  label="Stop Number" required v-model="stopnumber" type="number"> </v-text-field>
                </v-col>
              <v-col cols="12" md="6">
                <v-menu
                  ref="menu"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="pickupTime"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="pickupTime" aria-required="true" label="PickUp Time" prepend-icon="mdi-clock-time-four-outline" readonly v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-time-picker v-if="menu2" v-model="pickupTime" full-width format="24hr" @click:minute="$refs.menu.save(pickupTime)"></v-time-picker>
                </v-menu>
              </v-col>
                <v-col cols="12" md="6">
                <v-menu
                  ref="menus"
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="dropTime"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="dropTime" aria-required="true" label="Drop Time" prepend-icon="mdi-clock-time-four-outline" readonly v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-time-picker v-if="menu1" v-model="dropTime" full-width format="24hr" @click:minute="$refs.menus.save(dropTime)"></v-time-picker>
                </v-menu>
              </v-col>
              <v-col style="right:300px;" cols="12" md="6">
                  <v-card-actions class="justify-end">
                    <v-btn color="success" type="submit">Save</v-btn>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </form>
    </div>
    <div class="modal" :class="{ 'is-active': enableEditBusRouteModal }">
        <form @submit.prevent="editSaveRoute">
          <v-card>
            <v-toolbar dark color="darkblue">
              <v-toolbar-title> Edit Bus Stop For Bus Route - {{ busRoute}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn icon dark @click="toggleStaffModal, clearEditBusRoute()">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <v-row style="width:1000px;">
                <v-col cols="12" md="6">
                  <v-text-field  label="Pick Up Stop" required v-model="pickUpStop" type="text"> </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field   label="Nearest LandMark" required v-model="nearestLandMark" type="text"> </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field label="Lattitude" v-model="lattitude" type="text"> </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field label="Longitude" v-model="longitude" type="text"> </v-text-field>
                </v-col>
                 <v-col cols="12" md="6">
                  <v-text-field  label="Distance" required v-model="distance" type="number"> </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field  label="Stop Number" required v-model="stopnumber" type="number"> </v-text-field>
                </v-col>
              <v-col cols="12" md="6">
                <v-menu
                  ref="menus1"
                  v-model="menu3"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="pickupTime"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="pickupTime" aria-required="true" label="PickUp Time" prepend-icon="mdi-clock-time-four-outline" readonly v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-time-picker v-if="menu3" v-model="pickupTime" full-width format="24hr" @click:minute="$refs.menus1.save(pickupTime)"></v-time-picker>
                </v-menu>
              </v-col>
                <v-col cols="12" md="6">
                <v-menu
                  ref="menus2"
                  v-model="menu4"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="dropTime"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="dropTime" aria-required="true" label="Drop Time" prepend-icon="mdi-clock-time-four-outline" readonly v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-time-picker v-if="menu4" v-model="dropTime" full-width format="24hr" @click:minute="$refs.menus2.save(dropTime)"></v-time-picker>
                </v-menu>
              </v-col>
              <v-col style="right:300px;" cols="12" md="6">
                  <v-card-actions class="justify-end">
                    <v-btn color="success" type="submit">Save</v-btn>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </form>
    </div>
  </div>
</template>

<script>
import VCardComponent from '@/components/template/VCardComponent'
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
import Utils from '@/utils'
export default {
  name: 'viewVehicleBusRouteStop',
  components: {
    MaterialCard,
    VCardComponent
  },
  props: ['busRouteID'],
  data () {
    return {
      search: '',
      isLoading: false,
      loadingComponent: null,
      academicYears: [],
      academicYearID: '',
      stages: [],
      inProgress: false,
      franchiseeArr: [],
      enableStaffModal: false,
      vehicleBusRouteStop: [],
      enableEditBusRouteModal: false,
      pickUpStop: '',
      busRoute: '',
      nearestLandMark: '',
      lattitude: '',
      longitude: '',
      stopnumber: '',
      dropTime: null,
      pickupTime: null,
      distance: '',
      menu2: false,
      menu1: false,
      menu3: false,
      menu4: false,
      total: '',
      editStopID: '',
      headers: [
        { text: 'Bus Route', value: 'vehicleBusRoute.routeName', sortable: true },
        { text: 'Nearest LandMark', value: 'nearestLandMark', sortable: true },
        { text: 'Pick Up Stop', value: 'pickUpStop', sortable: true },
        { text: 'Pick Up Time', value: 'pickupTime', sortable: true },
        { text: 'Drop Time', value: 'dropTime', sortable: true },
        { text: 'Distance', value: 'distance', sortable: true },
        { text: 'StopNumber', value: 'StopNumber', sortable: true },
        { text: 'Action', value: 'actions', sortable: false, align: 'center' }
      ]
    }
  },
  async created () {
    await this.getYear()
    await this.getFranchiseeList()
    await this.Save()
  },
  methods: {
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    getYear: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
        this.academicYears = data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find(y => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''

        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    getFranchiseeList: async function () {
      try {
        const response = await http.get(`${constants.API_URL}/api/franchisee`)
        let data = response.data
        this.franchiseeArr = data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching franchisee', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    toggleStaffModal: function () {
      this.enableStaffModal = !this.enableStaffModal
    },
    Save: async function () {
      this.vehicleBusRouteStop = []
      this.total = ''
      try {
        let getParam = {}
        getParam.busRouteID = this.busRouteID
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/transport/vehicledetails/vehiclebusroutestop`, {
          params: getParam
        })

        if (data.length === 0) {
          this.$buefy.dialog.alert({
            title: 'No Data',
            message: 'No Data Found',
            type: 'is-danger',
            hasIcon: true,
            icon: 'times-circle',
            iconPack: 'fa',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        } else {
          this.vehicleBusRouteStop = data
          console.log(' this.vehicleBusRouteStop ', this.vehicleBusRouteStop)
          this.busRoute = this.vehicleBusRouteStop[0].vehicleBusRoute.routeName
          this.total = this.vehicleBusRouteStop.length
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Saving Data', errorMessage)
      }
    },
    SaveRoute: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        let formData = new FormData()
        formData.append('busRouteID', this.busRouteID)
        formData.append('pickUpStop', this.pickUpStop)
        formData.append('nearestLandMark', this.nearestLandMark)
        formData.append('lattitude', this.lattitude)
        formData.append('longitude', this.longitude)
        formData.append('pickupTime', this.pickupTime)
        formData.append('dropTime', this.dropTime)
        formData.append('distance', this.distance)
        formData.append('StopNumber', this.stopnumber)
        for (var pair of formData.entries()) {
          console.log(pair)
        }
        this.hasClicked = true
        await http.post(`${constants.API_URL}/api/transport/vehicledetails/vehiclebusroutestop`, formData)
        this.loader = false
        this.loadingComponent.close()
        await this.Save()
        this.clearEditRemark()
        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Saved successfully',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Details', errorMessage)
        this.lock = false
        this.hasClicked = false
        this.loader = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    editBusRoute: async function (id) {
      try {
        this.isLoading = true
        this.editStopID = id
        const { data } = await http.get(`${constants.API_URL}/api/transport/vehicledetails/vehiclebusroutestop/${id}`, {
        })
        console.log(data)
        this.pickUpStop = data.pickUpStop
        this.nearestLandMark = data.nearestLandMark
        this.lattitude = data.lattitude
        this.longitude = data.longitude
        this.pickupTime = data.pickupTime
        this.dropTime = data.dropTime
        this.distance = data.distance
        this.stopnumber = data.StopNumber
        this.toggleEditBusRouteModal()
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Saving Data', errorMessage)
      }
    },
    toggleEditBusRouteModal: function () {
      this.enableEditBusRouteModal = !this.enableEditBusRouteModal
    },
    editSaveRoute: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        let formData = new FormData()
        formData.append('pickUpStop', this.pickUpStop)
        formData.append('nearestLandMark', this.nearestLandMark)
        formData.append('lattitude', this.lattitude)
        formData.append('longitude', this.longitude)
        formData.append('pickupTime', this.pickupTime)
        formData.append('dropTime', this.dropTime)
        formData.append('distance', this.distance)
        formData.append('StopNumber', this.stopnumber)
        for (var pair of formData.entries()) {
          console.log(pair)
        }
        this.hasClicked = true
        await http.put(`${constants.API_URL}/api/transport/vehicledetails/vehiclebusroutestop/${this.editStopID}`, formData)
        this.loader = false
        this.loadingComponent.close()
        await this.Save()
        this.clearEditBusRoute()
        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Saved successfully',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Details', errorMessage)
        this.lock = false
        this.hasClicked = false
        this.loader = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    clearEditRemark: function () {
      this.pickUpStop = ''
      this.nearestLandMark = ''
      this.lattitude = ''
      this.longitude = ''
      this.pickupTime = null
      this.dropTime = null
      this.distance = ''
      this.enableStaffModal = !this.enableStaffModal
    },
    clearEditBusRoute: function () {
      this.pickUpStop = ''
      this.nearestLandMark = ''
      this.lattitude = ''
      this.longitude = ''
      this.pickupTime = null
      this.dropTime = null
      this.distance = ''
      this.enableEditBusRouteModal = !this.enableEditBusRouteModal
    }
  }
}
</script>
